import clsx from 'clsx';
import { TfNotification } from 'api';
import { TfNotice } from 'api/notices';
import * as React from 'react';
import { Text } from 'ui';
import { ActivityMenu } from './activity-menu';
import { NotificationListItem } from './notification-list-item';
import { UpdateListItem } from './update-list-item';
import styles from './notifications-drawer.module.css';

export type NotificationsListItem = TfNotification | TfNotice;

export function isNotice(item: NotificationsListItem): item is TfNotice {
    return 'copy' in item;
}

interface NotificationsListProps {
    items: NotificationsListItem[];
    notifications: TfNotification[];
}

export const NotificationsList: React.FC<NotificationsListProps> = ({ items, notifications }) => {
    let lastGroupKey: TfNotification['groupKey'];

    return (
        <div role="list">
            {items.map((item) => {
                const groupKey = isNotice(item) ? undefined : item.groupKey;
                const activity = isNotice(item) ? undefined : item.activities?.[0];
                const isDeleting = !isNotice(item) && item.isDeleting;
                let divider;

                if (activity && groupKey !== undefined && groupKey !== lastGroupKey) {
                    divider = (
                        <div className={clsx(styles['item'], { [styles['deleting']]: isDeleting })}>
                            <div>
                                <div className={styles['group-header']}>
                                    <Text as="h3" variant="title-medium">
                                        {activity.name}
                                    </Text>
                                    <ActivityMenu groupKey={groupKey} notifications={notifications} />
                                </div>
                            </div>
                        </div>
                    );
                } else if (groupKey === undefined && lastGroupKey !== undefined) {
                    divider = <hr className={styles['divider']} />;
                }

                if (!isDeleting) {
                    lastGroupKey = groupKey;
                }

                return (
                    <div key={item.id} role="listitem" className="notification-list-item-container">
                        {divider}
                        {isNotice(item) ? (
                            <div className={styles['item-inner']}>
                                <UpdateListItem notice={item} />
                            </div>
                        ) : (
                            <NotificationListItem notification={item} />
                        )}
                    </div>
                );
            })}
        </div>
    );
};
